module.exports = __webpack_public_path__ + "img/menu-energy.741e48ef.svg";